import { FC, MouseEventHandler, useRef } from "react";
import { ThumbsUp as ThumbsUpIcon, ThumbsDown as ThumbsDownIcon } from "react-feather";

export enum FeedbackPolarity {
    Positive,
    Negative
}

interface FeedbackPolaritySelectorProps {
    onPositiveFeedbackButtonClick: () => void;
    onNegativeFeedbackButtonClick: () => void;
    value: FeedbackPolarity | undefined;
    extendHeight: (extend: boolean) => void;
}

const FeedbackPolaritySelector: FC<FeedbackPolaritySelectorProps> = (props) => {
    const handlePositiveFeedbackButtonClick: MouseEventHandler<HTMLButtonElement> = () => {
        feedbackElement?.scrollIntoView(false);
        props.onPositiveFeedbackButtonClick();
        props.extendHeight(false);
    }
    
    const handleNegativeFeedbackButtonClick: MouseEventHandler<HTMLButtonElement> = () => {
        feedbackElement?.scrollIntoView(false);
        props.onNegativeFeedbackButtonClick();
    }

    const feedbackElement = document.getElementById("feedbackElement");
    
    return (
        <div>
            <div className="row feedback-container">
                <span className="col half left-feedback-col noMargin">
                    <button
                        type="button"
                        id="positive"
                        onClick={handlePositiveFeedbackButtonClick}
                        className={"button thumbs-up " + (props.value === FeedbackPolarity.Positive ? "selected" : "") + " feedbackButtonHeightAdjust"}
                    >
                        <ThumbsUpIcon className="thumbs-up-img" />
                    </button>
                </span>
                <span className="col half noMargin">
                    <button
                        type="button"
                        id="negative"
                        onClick={handleNegativeFeedbackButtonClick}
                        className={"button thumbs-down " + (props.value === FeedbackPolarity.Negative ? "selected" : "") + " feedbackButtonHeightAdjust"}
                    >
                        <ThumbsDownIcon className="thumbs-down-img" />
                    </button>
                </span>
            </div>
            {props.value !== undefined ? (
                <>
                    <hr className="hrAdjust hrAdjustBottom hrGreen" />
                </>
            ) : (

                <>

                </>
            )}
        </div>
        
    );
}

export default FeedbackPolaritySelector;